import { z } from 'zod';

export const HelpDeskValidator = z.object({
  subject: z.string().min(1, {
    message: 'Please select subject.',
  }),
  description: z.string().optional(),
  priority: z.string(),
  tags: z.array(z.string()),
  attachments: z.array(z.unknown()),
});

export type HelpDeskFormData = z.infer<typeof HelpDeskValidator>;
